import type { WidgetDefinition } from "@nexus/widget-sdk";
import widgetModule from ".";
import { settings } from "./settings";

export const definition: WidgetDefinition = {
  id: "piracy-audience-trend",
  module: widgetModule,
  catalog: {
    description:
      "Piracy audience samples split by block safety, the observed traffic, and the periods during which blocking ran.",
    domain: "audience",
    visual: "Area chart",
    purposes: ["reporting"],
    audiences: ["analyst", "client"],
  },
  layout: { kind: "chart", skeletonMinHeight: "26rem" },
  settings,
  // It highlights the period a linked spotlight has on show.
  links: { blockingPeriodSelection: { role: "follower", dataKey: "series" } },
  defaultLayoutClassName: "col-span-12",
};
